<template>
  <div class="dialog_container">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      class="activityCostDialog"
      @close="dialogCloseHandle"
    >
      <div class="content">
        <div v-if="confirmStatus">
          您正在调整费用所属部门，调整金额为{{ form.money }}，费用个数为{{
            form.num
          }}个,是否确认！
        </div>
        <el-form ref="form" :rules="rules" :model="form" v-else>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="费用类型：" label-width="85px">
                {{ form.expenseTypeName }}
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="调整的费用个数：" label-width="115px">
                {{ form.num }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="年份：" label-width="85px">
                {{ form.year }}
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="调整的费用总额：" label-width="115px">
                {{ form.money }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="原费用部门：" label-width="85px">
                {{ form.deptName }}
              </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item
                label="新费用部门："
                label-width="115px"
                prop="newDeptName"
              >
                <el-select
                  v-model="form.newDeptName"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :remote-method="remoteMethod"
                  placeholder="请输入新费用部门"
                >
                  <el-option
                    v-for="item in deptNameList"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.deptCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="footer">
        <el-button type="primary" @click="dialogCloseHandle">取消</el-button>
        <el-button type="primary" @click="handleSubmitDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isNotEmpty } from '@/utils/utils';
import { budgetPerformanceApi } from '../../service';

export default {
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '费用部门调整',
      dialogWidth: '900px',
      confirmStatus: false,
      form: {
        expenseTypeName: '',
        num: 0,
        money: 0,
        newDeptName: '',
        year: 0,
        deptName: ''
      },
      rules: {
        newDeptName: [
          { required: true, message: '请选择新费用部门', trigger: 'change' }
        ]
      },
      deptNameList: []
    };
  },
  props: {
    expensesDialogVisible: {
      type: Boolean,
      default: false
    },
    selectionList: {
      type: Array,
      default: () => []
    },
    detailsData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    expensesDialogVisible: {
      immediate: true,
      handler (val) {
        this.dialogVisible = val;
        this.confirmStatus = false;
        this.dialogTitle = '费用部门调整';
        this.dialogWidth = '900px';
        this.$set(this.form, 'newDeptName', '');
      }
    },
    selectionList: {
      immediate: true,
      deep: true,
      handler (val) {
        let allMoney = 0;
        const selectionList = this.selectionList;
        this.$set(this.form, 'num', this.selectionList.length);
        if (this.selectionList.length > 0) {
            allMoney = selectionList.reduce((prev, curr) => {
              if (curr.flowStat === 60) {
                return (prev += curr.writeOffAmount);
              } else {
                return (prev += curr.applyAmount);
              }
            }, 0);
        }
        this.$set(this.form, 'money', allMoney);
      }
    },
    detailsData: {
      immediate: true,
      deep: true,
      handler (val) {
        if (isNotEmpty(this.detailsData)) {
          this.$set(this.form, 'year', this.detailsData.year);
          this.$set(
            this.form,
            'expenseTypeName',
            this.detailsData.expenseTypeName
          );
          this.$set(this.form, 'deptName', this.detailsData.deptName);
        }
      }
    }
  },
  methods: {
    remoteMethod (e) {
      budgetPerformanceApi
        .getDeptNameList({ deptName: e, expenseTypeCode: this.detailsData.expenseTypeCode })
        .then(res => {
          if (res.status === '200') {
            this.deptNameList = res.data;
          }
        });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    handleSubmitDialog () {
      if (!this.confirmStatus) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.confirmStatus = true;
            this.dialogTitle = '提醒';
            this.dialogWidth = '700px';
          } else {
            return false;
          }
        });
      } else {
        let expenseBelongIds = [];
        this.selectionList.forEach(item => {
          expenseBelongIds.push(item.expenseBelongId);
        });
        const index = this.deptNameList.findIndex(item => item.deptCode === this.form.newDeptName);
        const params = {
          expenseBelongIds,
          deptCode: this.deptNameList[index].deptCode,
          deptName: this.deptNameList[index].deptName
        };
        budgetPerformanceApi.setExpenseDept(params).then(res => {
          if (res.status === '200') {
            this.$message({
              message: '调整成功！',
              type: 'success'
            });
            this.$emit('handleDeptNameSuccess');
            this.$emit('dialogCloseHandle');
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog_container {
  .content {
    ::v-deep .el-form-item {
      display: flex;
      .el-form-item__content {
        margin-left: 0px !important;
        flex: 1;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
